import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useStore } from "@/lib/userDetails/UserDetails";
// import { toast } from "react-hot-toast";
// import { AlertTriangle } from "lucide-react";

interface NavigationHandlerProps {
  data: {
    data: {
      state: string | null;
      aadharImage: string | null;
      profileImage: string | null;
    };
  };
}

const NavigationHandler = ({ data }: NavigationHandlerProps) => {
  const { setUser, setAuthenticated } = useStore();
  const navigate = useNavigate();
  const token = Cookies.get("token");
  const { isAuthenticated } = useStore();
  const [aadharImage, setAadharImage] = useState<string | null>(null);
  const [initialLoad, setInitialLoad] = useState(true);
  const url = window.location.href;

  useEffect(() => {
    if (initialLoad) {
      setInitialLoad(false);
      return;
    }
    if (!data?.data) {
      return;
    }

    setAadharImage(data?.data.aadharImage);
    if (data?.data.state === "EMAIL") {
      // alert("Please verify your email address");
      if (url.includes("auth/emailVerification")) {
        return;
      } else {
        if (url.includes("auth/verify-email")) return;
        Cookies.remove("token");
        // @ts-ignore
        setUser(null);
        setAuthenticated(false);
        navigate("/auth/verify-email");
        return;
      }
    }

    // if (isAuthenticated && token) {
    //   if (!data?.data.aadharImage) {
    //     navigate("/my-profile");
    //     return;
    //   }
    // }

    if (token !== undefined && isAuthenticated) {
      if (data?.data?.state === "USER_DETAILS") {
        if (url.includes("my-profile")) return;
        // toast(
        //   (t) => (
        //     <div className="flex items-start gap-2 w-full">
        //       <AlertTriangle className="h-6 w-6 text-amber-500" />
        //       <div className="flex-1">
        //         <h3 className="font-semibold text-lg">Complete Your Profile</h3>
        //       </div>
        //       <button
        //         onClick={() => {
        //           toast.dismiss(t.id);
        //         }}
        //         className="px-4 py-2 text-sm font-medium text-white bg-amber-500 rounded-lg hover:bg-amber-600"
        //       >
        //         Complete Now
        //       </button>
        //     </div>
        //   ),
        //   {
        //     duration: 5000,
        //     position: "top-right",
        //     className: "bg-white shadow-lg rounded-lg p-4 max-w-md",
        //   }
        // );
        navigate("/my-profile");
        return;
      }
    }
  }, [
    data,
    navigate,
    token,
    isAuthenticated,
    aadharImage,
    initialLoad,
    data?.data?.aadharImage,
    setAadharImage,
  ]);

  return null;
};

export default NavigationHandler;
